import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import Home from './views/Home.vue'

import User from '@/model/User'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requireLogin: false
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/forgot-password',
      name: 'forgotPassword',
      component: () => import('./views/ForgotPassword.vue')
    },
    {
      path: '/activate-account',
      name: 'activateAccount',
      component: () => import('./views/ActivateAccount.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./views/Contact.vue')
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: () => import('./views/Imprint.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./views/Privacy.vue')
    },
    {
      path: '/chemg',
      name: 'chemg',
      component: () => import('./views/Reports.vue'),
      props: {
        productType: 'chemg'
      },
      meta: {
        requireLogin: true,
        requirePrivileges: ['chemg', 'admin']
      }
    },
    {
      path: '/wrmg',
      name: 'wrmg',
      component: () => import('./views/Reports.vue'),
      props: {
        productType: 'wrmg'
      },
      meta: {
        requireLogin: true,
        requirePrivileges: ['wrmg', 'admin']
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('./views/Faq.vue')
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('./views/Account.vue'),
      meta: {
        requireLogin: true
      }
    },
    {
      path: '/faq/:slug',
      name: 'faqEntry',
      component: () => import('./views/FaqEntry.vue')
    },
    {
      path: '/admin/users',
      name: 'admin/users',
      component: () => import('./views/admin/Users.vue'),
      meta: {
        requireLogin: true,
        requirePrivileges: ['admin', 'manage-users']
      }
    },
    {
      path: '/admin/employers',
      name: 'admin/employers',
      component: () => import('./views/admin/Employers.vue'),
      meta: {
        requireLogin: true,
        requirePrivileges: ['admin', 'manage-employers']
      }
    },
    {
      path: '/admin/faq',
      name: 'admin/faq',
      component: () => import('./views/admin/Faq.vue'),
      meta: {
        requireLogin: true,
        requirePrivileges: ['admin']
      }
    },
    {
      path: '/admin/info',
      name: 'admin/info',
      component: () => import('./views/admin/Info.vue'),
      meta: {
        requireLogin: true,
        requirePrivileges: ['admin']
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if ((typeof to.meta.requireLogin !== 'undefined' && to.meta.requireLogin === true) ||
      typeof to.meta.requirePrivileges !== 'undefined') {
    // login or specific groups required
    if (store.state.currentUser === null) {
      // but not logged in
      next('/login')
      return
    }
  }

  if (typeof to.meta.requirePrivileges !== 'undefined') {
    // check if the user has at least one of the necessary privileges
    if (!(store.state.currentUser instanceof User)) {
      next('/')
      return
    }
    var hasAccess = to.meta.requirePrivileges.reduce((p, c) => p || store.state.currentUser.hasPrivilege(c), false)
    if (!hasAccess) {
      next('/login')
      return
    }
  }

  next()
})

export default router
